Weglot.on('initialized', function (){
  const locale = Weglot.getCurrentLang();
  if(locale === 'de') {
    $('.article-knowledge__listing').css("display","block");
    $('#a_locale').attr('href',"/");
    $('.prod_3dee_title').html('von');
    $('.style_block_de').html('<style>@media (max-width: 900px) {.add-to-basket.--configurator-is-open #js-stop-sticky .add-to-basket__footer__purchase { height: 11.08rem;}}</style>');           
    $('.style_block_de1').html('<style>.footer__seo--text.mobile_seo-text ul li:last-child {display: none !important;}</style>');
	// For the Journal Landing page - Knowledge section at the bottom     
    $('.knowledge-article__category-product').html('produkt');
    $('.knowledge-article__category-vitality').html('vitalität');
    $('.knowledge-article__category-workplace').html('arbeitsplatz');
  } else {
    $('.article-knowledge__listing').css("display","none");
    
    $('.li_link_title').each(function(element){
      if($(this).attr('data-li-title') === 'Shipping' || $(this).attr('data-li-title') === "Kennis" || $(this).attr('data-li-title') === "Karriere" || $(this).attr('data-li-title') === "Wissen" || $(this).attr('data-li-title') === "Returns" || $(this).attr('data-li-title') === "Verzendvoorwaarden" || $(this).attr('data-li-title') === "Keert terug" || $(this).attr('data-li-title') === "Annuleringsbeleid" || $(this).attr('data-li-title') === "Algemene voorwaarden " || $(this).attr('data-li-title') === "Betaling" || $(this).attr('data-li-title') === "Gegevensbescherming" || $(this).attr('data-li-title') === "Datenschutz für Bewerber"){
        $(this).css('display',"none");
      }
    });
    $('.li_link_title1').each(function(element){
      if($(this).attr('data-li-title') === "Height adjustable desks" ) {
        $(this).css('display',"none");
        $(this).parent().css('display','none');

      }

    });

    // $('.li_link_title2').each(function(element){
    //   if($(this).attr('data-li-title') === "Height adjustable desks" || $(this).attr('data-li-title') === "In de hoogte verstelbare tafels" || $(this).attr('data-li-title') === "Höhenverstellbare Tische") {
    //     $(this).css('display',"none");
    //     $(this).parent().css('display','none');

    //   }
    // });
    $('.faqs__list .faqs__group').each(function(element){
      if($(this).attr('id') === 'Fragen-und-Antworten-zum-Aeris-Active-Office' || $(this).attr('id') === 'Aeris Active-Office') {
        $(this).css('display',"none");
        $(this).parent().css('display','none');
      }
    });
    
    $('.product-carousel__slide.swiper-slide.active-office').remove();
    const swiper = document.querySelector('.js-el__product-carousel').swiper;
    swiper.updateSlides();
    $('.footer__seo--text.desktop_seo-text').css('display', 'none');
    $('.header__mobile-nav__menuitem__links li a[href="/products/aeris-single-desk"]').css('display', 'none');
    $('.custom_muuri_active-office').css('display','none');
    $('#a_locale').attr('href',"/");
    $('.de_block').css("display","none");
    $('.locale_de_link').attr('href','en'+$('.locale_de_link').attr('href'));
    
    $('.accessories-carousel__slide[data-product-handle="active-office-buch"]').remove();
  }
  if(locale === "en") {
    $('.prod_3dee_title').html('of');
  }
  if(locale === 'nl') {
    $('.prod_3dee_title').html('van');
  }
  if(locale === 'fr') {
    $('.prod_3dee_title').html('van');
  }
  if(locale === 'it') {
    $('.prod_3dee_title').html('di');
  }

  // expand button logic
  requestAnimationFrame(() => {
    if(document.querySelectorAll('.js-expand-button')) {
      document.querySelectorAll('.js-expand-button').forEach((item) => {
        let readLessText = item.querySelector('.read-less').textContent, readMoreText = item.querySelector('.read-more').textContent;
        let oldText = item.querySelector('.text').textContent.split('...')[0];

        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (e.target.tagName === 'A') {
            // open link in new tab
            window.open(e.target.href, '_blank');
            return;
          }
          if (!item.dataset.open || item.dataset.open == "false") {
            if (item.dataset.fullText) {
              item.querySelector('.text').innerHTML = `${item.dataset.fullText} <span class="underline">${readLessText}</span>`;
              // item.querySelector('.text').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest"});
              item.dataset.open = "true";
            }
          } else {
            item.querySelector('.text').innerHTML = `${oldText}... <span class="underline">${readMoreText}</span>`;
            item.dataset.open = "false";
          }
        });
      });
    }
  });
});


function resizeAcc() {
  var accWidth = $('#add-to-basket').width()/2;
  $('#fixed-image').css("width" , accWidth + "px");
 
}
function resizeConf() {
   var accHeight = $('#topImageDiv').height();
  $('.add-to-basket__configurator').css('max-height', accHeight + "px");
}

$(document).ready(function () { 
  $('.js-fn__configurator-open').on('click', function() {
  	resizeConf();
  })
  resizeAcc();
	 $(window).resize(function () {
      resizeAcc();
    }) 
 
const getOffsetTop = element => {
  let offsetTop = 0;
  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

// sticky image

 if (($('#fixed-image').length > 0) && ($( window ).width() > 900 )) {
	
     var scrolling = throttle(function () {
       stickyImage();        
    }, 100);
   
	window.addEventListener('scroll', scrolling);  
	

	var fixedImage = document.getElementById("fixed-image");
	var bottomSlider = document.getElementById("js-stop-sticky");
   	var topSticky = document.getElementById("topImageDiv");

   var test = fixedImage.getBoundingClientRect().top;
   
	var sticky = getOffsetTop(fixedImage);
   	var stopSticky = getOffsetTop(topSticky);
   	var bottomSliderStop = getOffsetTop(bottomSlider)
   	var imageHeight = fixedImage.offsetHeight;
	function stickyImage() {
      
     		if ((window.pageYOffset > sticky) && (window.pageYOffset < (bottomSliderStop - imageHeight + bottomSlider.offsetHeight  )) && (window.pageYOffset > stopSticky )) {
				fixedImage.classList.add("sticky");              	
            } else {
            	fixedImage.classList.remove("sticky");              	
            }                   
     		if (window.pageYOffset > (bottomSliderStop - imageHeight + bottomSlider.offsetHeight )) {
      			topSticky.classList.add("sticky");
              fixedImage.classList.remove("sticky"); 
            } else {
            	topSticky.classList.remove("sticky");
            }
	}
}

  function resizeAcc() {
    var accWidth = $('.section__options').width();
    $('#fixed-image').css("width" , accWidth + "px");
  }

function throttle(func, interval) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = false;
        };
        if (!timeout) {
            func.apply(context, args);
            timeout = true;
            setTimeout(later, interval)
        }
    }
}

  
  
//   swopper readmore 
  (function(){
  
   const swopperShowDeskription = $('.add-to-basket__swopper_show_deskription');
    if ( swopperShowDeskription.length ) {
      swopperShowDeskription.on('click',function(e){
      	$(this).toggleClass('active');
        $(this).prev('.add-to-basker__box_text').toggleClass('active');
        $(this).parent().toggleClass('active');
      })
    	
    }
  })();
  
  // swopper show prev button 
  (function(){
  	const nextBtn = $('.add-to-basket-swopper .js-el__next-step-btn.add-to-basket__footer__progress-nav-mobile-btn');
    const prevBtn = $('.add-to-basket-swopper .js-el__prev-step-btn.add-to-basket__footer__progress-nav-mobile-btn');
    if(nextBtn.length && prevBtn.length){
      prevBtn.on('click',function(e){
        setTimeout(function(){
        if($('.add-to-basket-swopper .add-to-basket__footer__progress-step.--is-before-current').length < 2) {
        	prevBtn.removeClass('is_active');
        }
        },0)
         
      });
      nextBtn.on('click',function(e){
        prevBtn.addClass('is_active');

      })
    }
  
  })();
  
    (function(){
  	const nextBtn = $('.js-el__next-step-btn.add-to-basket__footer__progress-nav-mobile-btn');
    const prevBtn = $('.js-el__prev-step-btn.add-to-basket__footer__progress-nav-mobile-btn');
    if(nextBtn.length && prevBtn.length){
      prevBtn.on('click',function(e){
        setTimeout(function(){
        if($('.add-to-basket__footer__progress-step.--is-before-current').length < 2) {
        	prevBtn.removeClass('is_active');
        }
        },0)
         
      });
      nextBtn.on('click',function(e){
        prevBtn.addClass('is_active');

      })
    }
  
  })();
  
  // add_to_basket_footer_info_swopper toggle active
  (function(){
  	const designBtn = $('.add-to-basket-swopper .add-to-basket__footer__purchase .js-fn__configurator-open.btn');
    const closeBtn = $('.add-to-basket__configurator__header .js-fn__configurator-close');
    if(closeBtn.length){
      closeBtn.on('click',function(e){      
          	$('.add_to_basket_footer_info_swopper').removeClass('active');
      })
    }
    if(designBtn.length){
      designBtn.eq(0).on('click',function(e){
      	$('.add_to_basket_footer_info_swopper').addClass('active');
      })
    }
    
  	
  })();
  
//   add_to_basket_footer_info_swopper
    (function(){
      const activateListenner = $('.swopper_is_show_design_footer_mobile');
    	  	const configuratorLink = $('.add_to_basket_configurator__step_swopper .add-to-basket__configurator__option-summary__edit');
 	 	configuratorLink.on('click',function(){
   	    $('.add-to-basket__footer__purchase_desktop_swopper .add-to-basket__footer__configurator-add-to-cart').removeClass('--is-active');
  	});

      const configuratorLinkMobile = $('.add_to_basket_configurator__step_swopper .add-to-basket__configurator__option-item-mobile');
      configuratorLinkMobile.on('click',function(){
      	$('.add-to-basket__footer__purchase_desktop_swopper .add-to-basket__footer__configurator-add-to-cart').removeClass('--is-active');
      
      });
  
  })();
  
 });

// PINTEREST

function pintrkAddToCart(currency, productId, productCategory, variantId, value, orderQuantity, productName) {
  if (typeof pintrk != 'undefined') {
    pintrk('track', 'AddToCart', {
      currency: currency,
      line_items: [{
        product_id: productId,
        product_category: productCategory,
        product_variant_id: variantId,
        product_price: value / 100,
        product_quantity: orderQuantity,
        product_name: productName
      }]
    });
  }
}


// Configurator - Fix for Header not showing on mobile after clicking the X
$('.js-fn__configurator-close').click(function(){
  $('.header.js-el__header').removeClass('headroom--unpinned');
  $('.header.js-el__header').addClass('headroom--pinned');
});

/* 03-10-2021 */
$( function() {
  if($('#accordion').length){
    $( "#accordion" ).accordion({
          activate: function( event, ui ) {
              const list_id = $('.ui-accordion-header-active').data('id');
              $('.Compare__Dot').removeClass( "Compare__Dot-is-active" );
              $("."+list_id+"").addClass( "Compare__Dot-is-active" );
          }
    });
    $('.Compare__Dot').click(function(){
		var index=$(this).data('accordion') /* don't -1 */,accordion=$( "#accordion")
		if (accordion.accordion( "option", "active")===index){
			accordion.accordion( "option", "active", false )
		} else
			accordion.accordion( "option", "active", index )
		return false;
	})
  }
} );

/* Piperedge */
var swiper = new Swiper(".js-el__blocklist", {
  slidesPerView:"auto",
  scrollbar:{
    el:".js-el__blocklist-scrollbar",
    draggable:!0                                 
  }
})
var swiper = new Swiper(".js-el__testimonials-story", {
  loop: true,
  pagination:{
    el:".js-el__testimonials-pagination",
    type:"bullets",
    clickable : true
  },
  navigation: { 
    nextEl: ".swiper-button-next", 
    prevEl: ".swiper-button-prev" 
  }
  
});

const initSlides =()=>{

const swiper = new Swiper(".carousel-1", { 
  slidesPerView: "auto",
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  scrollbar: { el: ".carousel-scrollbar-1", hide: !1,draggable: !0, dragSize: "180px"} 
})


const swiper3 = new Swiper(".carousel-3", { 
  slidesPerView: "auto", 
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  scrollbar: { el: ".carousel-scrollbar-3", hide: !1, draggable: !0, dragSize: "180px" } 
})
const swiper4 = new Swiper(".carousel-4", { 
  slidesPerView: "auto", 
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  scrollbar: { el: ".carousel-scrollbar-4", hide: !1, draggable: !0, dragSize: "180px" } 
})
const swiper2 = new Swiper(".carousel-2", { 
  slidesPerView: "auto",
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, 
  scrollbar: { el: ".carousel-scrollbar-2", hide: !1, draggable: !0, dragSize: "180px" } 
})

var mySwiper = (function() {
	var $swiperContainer = document.querySelectorAll(".swiper-js-container-image");
    function init($this) {
      
        var $el = $this.querySelector('.swiper-container'),
			pagination = $this.querySelector('.swiper-pagination');
            

        var $swiper = new Swiper($el, {
        nested: true,
          enabled:false,
            breakpoints: {
              280: {
                slidesPerView: 1,
                enabled:true,
              },
              1200: {
                slidesPerView: 1,
                enabled:false,
              }
            },
          pagination: {
            el: pagination,
            clickable: true,
            type: 'bullets',
          }
        });
//       $swiper.update()
//       console.log($swiper)
         
    }
    
	// Events
	//$(document).ready(function() {
		if ($swiperContainer.length) {
			$swiperContainer.forEach((container)=>{
				init(container);
			})
		}
    //});
         
 
})();
}

initSlides();
window.addEventListener('resize', function () {
	initSlides()
})

// $(document).scroll(function() {
//   var objectTop = $('.add-to-basket-active-desk .add-to-basket__footer__progress').position().top;
//   var objectHeight = $('.add-to-basket-active-desk .add-to-basket__footer__progress').outerHeight();  
//   var windowScrollTop = $(window).scrollTop();
//   var windowHeight = $(window).height();

//  if((objectTop+objectHeight) <=  $('html').outerHeight())
//    console.log('sticky')
//  else
//   console.log('not sticky');
// });

//Appends the steps visible on desktop to mobile
  $('#steps').clone().contents().appendTo('#mobilesteps')

//Targets the popup button for substeps (due to no content for popups) and removes the element
$('.popup-mobile-swopper[data-target-substep="2"]').remove('span.popup-mobile-swopper');

//Functionality for popups to add a custom class to make popup open and close
const attachClickEventsSwopper = () => {

  document.querySelectorAll('.popup-mobile-swopper').forEach(ele => {
    ele.addEventListener('click', () => {
      const popupSelector = ele.dataset.popup;
      document.querySelector('.js-el__configurator-info-popup-container[data-popup="' + popupSelector + '"]').classList.add('--is-opened');
    })
  });

  document.querySelectorAll('.js-fn__configurator-close-popups').forEach(ele => {
    ele.addEventListener('click', () => {
      document.querySelectorAll('.js-el__configurator-info-popup-container').forEach(popup => {
        popup.classList.remove('--is-opened');
      });
    })
  });
}

attachClickEventsSwopper();

if($(window).width() <= 478){
  const mobileSteps = $('.add-to-basket__footer__progress-step');
  mobileSteps.on('click',function(){
    $('.add-to-basket__footer__purchase_desktop_swopper .add-to-basket__footer__configurator-add-to-cart').removeClass('--is-active');
  
  });
}

document.querySelectorAll('.personalisation-popup-open').forEach(ele => {
  ele.addEventListener('click', () => {
    document.querySelector('.aeris-personalisation-popup').style.display = 'block';
  })
})

function checkClick(){
  if( document.getElementById("checkbox").checked ){
    document.getElementById("engraveAddToCart").disabled = false;
  } else {
    document.getElementById("engraveAddToCart").disabled = true;
  } 
};
